import React from 'react'
import { Alert } from 'antd'
import PropTypes from 'prop-types'

/**
 * A component that displays error messages with special formatting for compilation errors
 */
const CompilationErrorAlert = ({ errorMessage, style = {} }) => {
    if (!errorMessage) return null
    
    // Check if the message appears to be a compilation error with line numbers and file references
    const isCompilationError = errorMessage.includes('Compilation Error') || 
                              (errorMessage.includes('.java:') && errorMessage.includes('error:'))
    
    if (isCompilationError) {
        return (
            <Alert
                message="Compilation Error"
                description={
                    <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                        <pre style={{ 
                            fontFamily: 'monospace', 
                            whiteSpace: 'pre-wrap',
                        }}>
                            {errorMessage}
                        </pre>
                    </div>
                }
                type="error"
                showIcon
                style={{ marginBottom: 16, ...style }}
            />
        )
    }
    
    // For regular error messages
    return (
        <Alert 
            message="Error"
            description={errorMessage} 
            type="error" 
            showIcon
            style={{ marginBottom: 16, ...style }}
        />
    )
}

CompilationErrorAlert.propTypes = {
    errorMessage: PropTypes.string,
    style: PropTypes.object
}

export default CompilationErrorAlert 